import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { Card } from 'routes/shared/components'
import { css } from '@emotion/core'

import * as styles from './styles'

// Direct inline style to force disable hover effect
const disableHoverStyle = css`
  &::before {
    display: none !important;
    content: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }
  
  &:hover::before {
    display: none !important;
    content: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    top: 100% !important;
  }
`

const ChooseWinnerComponent = ({ value, options, onChangeProxy }) => (
  <menu css={styles.menu}>
    {options.map(({ id, value: optValue, logo, isCustomEvent }) => {
      const choosen = id === value
      // Determine if this is a custom event (either by id or flag)
      const isCustomEventItem = id === 'CUSTOM_EVENT' || isCustomEvent

      return (
        <Margin
          all={2}
          key={id}
          as="li"
          css={[styles.item, isCustomEventItem && styles.noHoverWrapper]}
          data-id={id}
          onClick={onChangeProxy}
        >
          {/* Apply direct style to the Card for custom events */}
          <Card
            selected={choosen}
            logo={!isCustomEventItem ? logo : null}
            label={optValue || id}
            css={isCustomEventItem ? disableHoverStyle : undefined}
          >
            <Text size={11}>{optValue}</Text>
          </Card>
        </Margin>
      )
    })}
  </menu>
)

ChooseWinnerComponent.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape()),
  onChangeProxy: PropTypes.func,
}

export default ChooseWinnerComponent
